import { getDocumentListColumns } from '@dealstack/frontend/shared/components/Documents/DocumentsTable/utils';
import { ExtendedColumnDef } from '@dealstack/frontend/shared/components/Table/MantineTable/useMantineTableWithPaginationFilteringSorting';
import { DocumentsRes } from '@dealstack/frontend/shared/dataExchange/services/shared/types';
import { I18Namespaces } from '@dealstack/shared/lib/common/i18n/i18n';
import { Row } from '@tanstack/react-table';
import { useMemo } from 'react';
import { TranslateFunction } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks.types';

interface UseDocumentListColumnsParams {
	tCapManage: TranslateFunction<I18Namespaces.CAP_MANAGE>;
	tCommon: TranslateFunction<I18Namespaces.COMMON_UI>;
	classifierFilters: string[];
	onRowClick: (row: Row<DocumentsRes>) => void;
	downloadFile: (fileId: string, dealId: string, fileName: string) => void;
	previewFile: (document: DocumentsRes, dealId: string) => void;
	removeDocument: (row: Row<DocumentsRes>) => void;
	dealId: string;
	targetId: string;
}

export const useDocumentListColumns = ({
	tCapManage,
	tCommon,
	classifierFilters,
	onRowClick,
	downloadFile,
	previewFile,
	removeDocument,
	dealId,
	targetId,
}: UseDocumentListColumnsParams): ExtendedColumnDef<DocumentsRes>[] => {
	return useMemo(
		() =>
			getDocumentListColumns({
				tCapManage,
				classifierFilters,
				tCommon,
				onRowClick,
				downloadFile,
				previewFile,
				removeDocument,
				dealId,
				targetId,
			}),
		[
			tCommon,
			tCapManage,
			classifierFilters,
			onRowClick,
			downloadFile,
			previewFile,
			removeDocument,
			dealId,
			targetId,
		]
	);
};
